import React from "react";
import { connect } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import { Calculator } from "lucide-react";
import { Form, InputNumber } from "antd";
import FormItem from "components/fields/FormItem";
import Button from "components/button";
import Card from "components/card";
import { 
	doSNCompute
} from "../../../redux/tool/toolState";
import { requiredField } from "utils/crudSagaHelper";
import { NumberFormatter } from "utils/index";


const BulletList = ({ items = [], gradient }) =>
  items.map((item, idx) => (
    <div key={idx} className="flex items-top gap-2 py-1">
      <div
        className={`w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 bg-gradient-to-r ${gradient}`}
      >
        <div className="w-2 h-2 rounded-full bg-white"></div>
      </div>
	  <div>
		<p className="text-base text-gray-700 font-bold">{item['benefits']}</p>
      	<p className="text-base text-gray-700">{item['description']}</p>
	  </div>
    </div>
  ));

const statutoryBenefits = [
	{
		benefits: "Social Security System",
		description: "All employees are required to become an SSS member.The SSS is in place to protect individuals in the situation where they are unable to work and where there will be a loss in income or financial burden"
	},
	{
		benefits: "Philhealth",
		description: "The medical insuance company of the Philippines is Philippines Heath Insurance Corporation and all employees are required toi contribute to this service. In return, members are provided with health and hospitalisation subsidies in the event that they or their dependent are hospitalised. "
	},
	{
		benefits: "Home Devel Mutual Fund",
		description: "Employees are required to contribute to the Home Development Mutual Fund. It is a government controlled organisation that provides the lowest interest housing and land acquisition loans to members with the intention of giving every Filipino the opportunity to own a house."
	},
	{
		benefits: "13th Month Pay",
		description: "The is a year end bonus that all employees are entitled to that is the equivalent of one months salary. The 13th month pay is to be given no later than December 24 each year. "
	},
	{
		benefits: "Night Differential",
		description: "An additional 10% of the employees hourly rate that is to be paid for work rendered by the employee between the hours of 10pm to 6am MNL. "
	}
];

const hyvidBenefits = [
	{
		benefits: "Health Maintenance Organisation",
		description: "This is a Hyvid benefit that is given to all employees upon their commencement. HMO provides health insurance for employees."
	},
	{
		benefits: "Annual Leave",
		description: "Each employee is entitled to 15 annual vacation leave days per year. If the employee does not use all 15 of these day in one given year they are able to carry over a maxium of 10 days into the following service year.  "
	},
	{
		benefits: "Sick Leave",
		description: "Each employee is entitled to 5 annual sick days per year. If the employee does not use all 5 of these days in one given year they can not be carried over into the following year."
	}
];

const SNCalculator = ({goCompute, resultData}) => {
	const [form] = Form.useForm();
	
	  const onSubmit = (formData) => {
		try {
		  goCompute(formData);
	
		} catch (error) {
		  console.error("Compute failed:", error);
		}
	  };
	

	return (
	    <div>
			<SummaryHeader
				title={"NOE Calculator"}
				icon={Calculator}
				description={"Compute the expected cost an employee per month"}
				color={"green"}
			/>
				
	      	<Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-emerald-200 my-6 p-6">
				<Form className="form"
					layout="vertical" 
					form={form} 
					onFinish={onSubmit}
				>
					<div className="flex flex-col md:flex-row md:items-end gap-4 w-full">
						<FormItem
							extra="w-full md:max-w-[300px]"
							label="Employee Salary PHP (gross/month)"
							name="employee_salary"
							rules={[requiredField()]}
						>
							<InputNumber type="text" 
								id="employee_salary"
								className="input-field w-full"
								maxLength={12}
								placeholder="0.00"
							/>
						</FormItem>
						
						<div className="w-full md:w-auto pb-2">
							<Button
								type="submit"
								className="crud-button w-full md:w-auto"
							>
								<Calculator className='w-4 h-4 me-1'/>
								Compute
							</Button>
						</div>
					</div>
					
				</Form>  		

			{resultData && 
				<Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-blue-200 p-6">
					
					<div className="flex gap-4">
						<div className="text-base font-bold">Employee Salary: </div>
						<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.employee_salary)}</div>
					</div>
					<div className="grid grid-cols-6 ml-4 mb-4">
						<div className="flex gap-4">
							<div className="text-base text-gray-700 font-bold">Basic Pay:</div>
							<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.basic_pay)}</div>
						</div>
						<div className="flex gap-4">
							<div className="text-base text-gray-700 font-bold">Allowance:</div>
							<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.allowance)}</div>
						</div>
					</div>
					
					<div className="flex gap-4">
						<div className="text-base font-bold">Statutory Benefits:</div>
						<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.total_statutory)}</div>
					</div>
					<div className="grid grid-cols-6 ml-4 mb-4">
						<div className="flex gap-4">
							<div className="text-base text-gray-700 font-bold">SSS:</div>
							<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.sss)}</div>
						</div>
						<div className="flex gap-4">
							<div className="text-base text-gray-700 font-bold">Philhealth:</div>
							<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.philhealth)}</div>
						</div>
						<div className="flex gap-4">
							<div className="text-base text-gray-700 font-bold">HDMF:</div>
							<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.pagibig)}</div>
						</div>
						<div className="flex gap-4">
							<div className="text-base text-gray-700 font-bold">13th Month Pay:</div>
							<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.bonus_13th_month)}</div>
						</div>
						<div className="flex gap-4">
							<div className="text-base text-gray-700 font-bold">HMO:</div>
							<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.hmo)}</div>
						</div>
					</div>

					<div className="flex gap-4 mb-4">
						<div className="text-base font-bold">Security Deposit:</div>
						<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.security_deposit)}</div>
					</div>
					
					<div className="flex gap-4 mb-4">
						<div className="text-base font-bold">Hyvid Service Fee (AUD):</div>
						<div className="text-base text-gray-700">$ {NumberFormatter(resultData?.service_fee)}</div>
					</div>
					<div className="flex gap-4">
						<div className="text-base font-bold">Total Monthly Staff Cost (AUD):</div>
						<div className="text-base text-gray-700">$ {NumberFormatter(resultData?.total_monthly_cost)}</div>
					</div>

					<div className="flex gap-4 mt-8">
						<div className="text-base">** AUD Exchage Rate: </div>
						<div className="text-base text-gray-700">Php {NumberFormatter(resultData?.forexRate)}</div>
					</div>
				</Card>
			}
			</Card>
			<div className="mt-5 h-full gap-4">
				
				<Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-blue-200 mb-5">
					<div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-b rounded-t-2xl p-3 grid items-start">
						<h4 className="text-[18px]">Statutory Benefits</h4>
					</div>
					<div className="p-6">
						<BulletList items={statutoryBenefits} gradient="from-purple-500 to-emerald-500" />
					</div>
				</Card>

				<Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-blue-200 mb-5">
					<div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-b rounded-t-2xl p-3 grid items-start">
						<h4 className="text-[18px]">Hyvid Benefits</h4>
					</div>
					<div className="p-6">
						<BulletList items={hyvidBenefits} gradient="from-purple-500 to-emerald-500" />
					</div>
				</Card>

				<Card className="flex flex-col rounded-2xl shadow-sm bg-white border-2 border-blue-200 mb-5">
					<div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-b rounded-t-2xl p-3 grid items-start">
						<h4 className="text-[18px]">Security Deposit</h4>
					</div>
					<div className="p-6">
						<p>The security deposit is equivalent to the accruing redundancy cost for the employee. 
							It is 8.5% of the employee's monthly salary (excluding government mandated benefits). 
							The security deposit is fully refundable upon cessation of the employee once all outstanding amounts have been paid.
						</p>
					</div>
				</Card>
			</div>
			
			
	    </div>
    );
};

const mapStateToProps = (state) => ({
  resultData: state.tool.snCompute?.data,
});

const mapDispatchToProps = (dispatch) => ({
  goCompute: (data) => dispatch(doSNCompute(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SNCalculator);